import React from 'react';
import { Mail, Phone, Calendar, User } from 'lucide-react';

const MessageHeader = ({ message, onClose }) => (
  <div className="message-modal-header">
    <div className="message-modal-sender">
      <User size={24} />
      <div>
        <h3>{message.name}</h3>
        <span className={`status-badge ${message.status}`}>{message.status}</span>
      </div>
    </div>
    <button className="modal-close-btn" onClick={onClose}>✕</button>
  </div>
);

export const MessageMeta = ({ message, formatDate }) => (
  <div className="message-modal-meta">
    <div className="meta-item">
      <Calendar size={16} />
      {formatDate(message.created_at)}
    </div>
    <div className="meta-item">
      <Mail size={16} />
      <a href={`mailto:${message.email}`}>{message.email}</a>
    </div>
    {message.phone && (
      <div className="meta-item">
        <Phone size={16} />
        <a href={`tel:${message.phone}`}>{message.phone}</a>
      </div>
    )}
  </div>
);

export default MessageHeader;
